<template>
  <div class="bg-img b-flex b-flex-column b-justify-center">
    <div class="b-flex b-flex-row  b-justify-center">
      <div class="tripwise b-flex b-flex-column">
        <span>TRIPWISE</span>
        <span class="travel">出行之上 管家相伴</span>
        <span class="tel">咨询电话：400-900-5788</span>
        <span class="weixin">魏女士 188-3573-0716（同微信）</span>
      </div>
      <div class="product">
        <span>差旅产品</span>
        <div class="pingtai" @click="toProduct">
          <span>一站式企业消费</span>
          <span>全场景管理平台</span>
        </div>
      </div>
      <div class="programme">
        <span>获取方案</span>
        <div class="content">
          <div class="item" @click="toGet">差旅解决方案</div>
          <div class="item" @click="toGet">费控解决方案</div>
          <div class="item" @click="toGet">支出解决方案</div>
        </div>
      </div>
      <div class="programme">
        <span>关于我们</span>
        <div class="content">
          <span class="item" @click="toOur">商务合作</span>
        </div>
      </div>
      <div class="ercode">
        <div>在线咨询</div>
        <img class="img" src="https://image.ceekee.com/pc/secondwebsite/erweima_zixun.png" />
      </div>
    </div>
    <div class="line"></div>
    <div class="bottom-content b-flex b-align-centenr b-justify-center">
      Copyright 2022-2023 苏州大管家信息科技有限公司 <a target="_blank" href="https://beian.miit.gov.cn/">ICP备案：苏ICP备2022008637号-1</a>
      <img src="https://image.ceekee.com/pc/tripwise/gongan.png">
			<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32059002003925">苏公网安备 32059002003925号</a></div>
  </div>
</template>

<script>
export default {
  methods:{
    toProduct(){
      this.$router.push("/productscheme");
    },
    toIndex(){
      this.$router.push("/");
    },
    toOur(){
      this.$router.push("/business");
    },
    toGet(){
      this.$router.push("/apply");
    }
  }
};
</script>

<style lang="less" scoped>
.bg-img {
  width: 100%;
  height: 440px;
  padding: 54px 0 0;
  background: url(https://image.ceekee.com/pc/secondwebsite/home_bg_bottom.png)
    no-repeat;
}
.tripwise {
  font-size: 32px;
  color: #ffffff;
  line-height: 32px;
  font-weight: 600;
  margin-right: 60px;
  .travel {
    font-size: 16px;
    color: #ffffff;
    line-height: 16px;
    margin-top: 24px;
  }
  .tel {
    font-size: 16px;
    color: #ffffff;
    line-height: 16px;
    margin-top: 42px;
  }
  .weixin {
    font-size: 16px;
    color: #ffffff;
    line-height: 16px;
    margin-top: 30px;
  }
}
.product {
  font-size: 20px;
  color: #ffffff;
  line-height: 20px;
  font-weight: 600;
  margin-right: 60px;
  .pingtai {
    font-size: 16px;
    color: #ffffff;
    line-height: 20px;
    font-weight: 400;
    width: 120px;
    margin-top: 36px;
    cursor: pointer;
  }
}
.programme {
  font-size: 20px;
  color: #ffffff;
  line-height: 20px;
  font-weight: 600;
  margin-right: 60px;
  .content {
    font-size: 16px;
    color: #ffffff;
    line-height: 16px;
    font-weight: 400;
    width: 112px;
    margin-top: 36px;
    .item {
      padding-bottom: 10px;
      cursor: pointer;
    }
  }
}
.ercode {
  font-size: 20px;
  color: #ffffff;
  line-height: 20px;
  font-weight: 600;
  
  .img {
    height: 138px;
    width: 138px;
    margin-top: 36px;
  }
}
.ercode-margin{
margin-right: 60px;
}

.line {
  width: 100%;
  height: 4px;
  opacity: 0.4;
  background: #eaeaea;
  margin-top: 110px;
}
.bottom-content {
  height: 80px;
  font-size: 14px;
  color: #ffffff;
  line-height: 14px;
  font-weight: 400;
}
.bottom-content img{
  margin-left: 10px;
  width: 15px;
}
.bottom-content a{
  margin-left: 5px;
  color: #fff;
}
</style>